import React, { useEffect, useState } from 'react'
import { useGetemployeeTrainings } from '../../redux/employee/hook/training'
import { PAGINATION_DEFAULT } from '../../utils/constants'
import DataTable from '../../components/datatable'
import TrainedEmployee from '../../components/modal/hr-section/employee-training/trained-employee'

const TrainingPage = () => {
  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  // const { user } = useSelector((state) => state.userSlice);
  const [tableType, setTableType] = useState('training')

  const switchFunction = () => {
    if (tableType === 'training') {
      setTableType('table')
    } else {
      setTableType('training')
    }
  }

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    search: '',
  })
  const { data: trainings } = useGetemployeeTrainings(
    pagination?.limit,
    pagination?.page,
    pagination?.search
  )

  const [showTrainedEmployee, setShowTrainedEmployee] = useState(false)
  const [trainedEmployeeData, setTrainedEmployeeData] = useState(null)

  const tableConfig = {
    headers: ['Training Name', 'Passing Criteria', 'Training Period'],
    keys: ['module_name', 'passing_criteria', 'period'],
    mobileHeader: {
      left: {
        title: 'Training',
        key: 'trainer_name',
      },
      right: {
        title: 'Period',
        key: 'period',
      },
    },
  }

  const actionConfig = [
    {
      name: 'Take Test',
      color: 'green',
      action: (id) => {
        let index = trainings.data.findIndex((item) => item.id === id)
        setShowTrainedEmployee(true)
        setTrainedEmployeeData(trainings.data[index])
      },
    },
  ]

  return (
    <>
      {showTrainedEmployee ? (
        <TrainedEmployee
          isOpen={showTrainedEmployee}
          trainedEmployeeData={trainedEmployeeData}
          closeModal={() => setShowTrainedEmployee(false)}
        />
      ) : null}
      <div className='flex flex-col bg-white shadow-md rounded w-full '>
        <DataTable
          data={trainings}
          tableConfig={tableConfig}
          actionConfig={actionConfig}
          updatePagination={(data) => setPagination(data)}
          computedActions={true}
          tableType={tableType}
          switchFunction={switchFunction}
          layoutSwitch={true}
          searchData={true}
          noCheck={true}
        />
      </div>
    </>
  )
}

export default TrainingPage
